module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "nav-breadcrumb-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "nav-breadcrumb"
  }, [_c('router-link', {
    attrs: {
      "to": "/goodsList"
    }
  }, [_vm._v("企业服务商城")]), _vm._v(" "), _vm._t("default")], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-68a6b65e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbread.vue
// module id = 330
// module chunks = 2